import { render } from "./ComposeMessageStep.vue?vue&type=template&id=376dacf6&scoped=true"
import script from "./ComposeMessageStep.vue?vue&type=script&lang=js"
export * from "./ComposeMessageStep.vue?vue&type=script&lang=js"

import "./ComposeMessageStep.vue?vue&type=style&index=0&id=376dacf6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376dacf6"]])

export default __exports__